// extracted by mini-css-extract-plugin
export default {"about_container":"Aboutus_about_container__S0RYR","leftside":"Aboutus_leftside__T1QAo","rightside":"Aboutus_rightside__1ET-N","about_row":"Aboutus_about_row__HpRhi"};